import { render, staticRenderFns } from "./FcRender.vue?vue&type=template&id=a0565788"
import script from "./FcRender.vue?vue&type=script&lang=js"
export * from "./FcRender.vue?vue&type=script&lang=js"
import style0 from "./FcRender.vue?vue&type=style&index=0&id=a0565788&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports